<app-spinner></app-spinner>
<!-- <router-outlet></router-outlet> -->
<div class="container-fluid mt-2 ms-0">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h4 class="fw-bold">Escalation Matrix</h4>
    <button class="btn hover-light" style="background-color: #226CE0;box-shadow: none; border-radius: 6px !important;"
      (click)="open(addEscalationModal)">
      <img src="../../../../assets/img/cfc/services/Plus.svg" alt="plus" style="width: 16px; height: 16px;">

      <span class="p-1 text-white">Add Rule</span>
    </button>
  </div>

 <div class="container-fluid mt-2 ms-0">

  <div class="row align-items-center mb-3">
    <!-- Left section: title -->
    <div class="col-12 col-md-6 mb-2 mb-md-0 d-flex align-items-center">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <circle cx="12" cy="12.5" r="9" stroke="black" stroke-width="2" />
        <path d="M16.5 12.5H12.25C12.1119 12.5 12 12.3881 12 12.25V9" stroke="black" stroke-width="2"
          stroke-linecap="round" />
      </svg>
      <span class="rule ms-2">Escalation Rules</span>
    </div>

    <!-- Right section: search box -->
   <div class="col-12 col-md-6 d-flex justify-content-md-end">
  <div class="input-group" style="max-width: 250px; width: 100%;">
    <span class="input-group-text bg-white border-end-0">
      <img src="../../../../assets/img/cfc/services/Icon.svg" alt="icon" style="width: 16px; height: 16px;">
    </span>
    <input type="text" class="form-control" placeholder="Search Escalation time..."
      [(ngModel)]="searchText" (input)="onSearchChange()">
  </div>
</div>


  </div>

</div>


  <div class="table-responsive">
    <table class="table table-bordered w-100 tableshadow">
      <thead class="table table-light">
        <tr>
          <th>Sr. No.</th>
          <!-- <th class="text-center">Category</th> -->
          <!-- <th class="text-center">Level</th> -->
          <!-- <th class="text-center">Officer Role</th> -->
          <th>Escalation Time (hrs)</th>
          <!-- <th class="text-center">Notification Modes</th> -->
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let rule of pagedRules ; let i=index">
    <td class="text-center">{{ i+1 }}</td>
          <!-- <td class="text-center">{{ rule.level }}</td> -->
          <!-- <td class="text-center">{{ rule.officerRole }}</td> -->
          <td>{{ rule.time }}</td>
          <!-- <td class="text-center">
            <ng-container *ngFor="let mode of rule.notificationModes">
              <span class="notification-badge me-1"
                [ngClass]="{'sms-badge':mode==='SMS','dashboard-badge':mode==='Dashboard','email-badge':mode==='Email'}">
                {{ mode }}
              </span>
            </ng-container>
          </td> -->
          <td>
            <button class="me-1 edit" (click)="onEdit(addEscalationModal,rule)">
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                <g clip-path="url(#clip0_582_5824)">
                  <path
                    d="M7.83325 3.16665H3.16659C2.81296 3.16665 2.47382 3.30713 2.22378 3.55718C1.97373 3.80723 1.83325 4.14637 1.83325 4.49999V13.8333C1.83325 14.1869 1.97373 14.5261 2.22378 14.7761C2.47382 15.0262 2.81296 15.1667 3.16659 15.1667H12.4999C12.8535 15.1667 13.1927 15.0262 13.4427 14.7761C13.6928 14.5261 13.8333 14.1869 13.8333 13.8333V9.16665M12.8333 2.16665C13.0985 1.90144 13.4582 1.75244 13.8333 1.75244C14.2083 1.75244 14.568 1.90144 14.8333 2.16665C15.0985 2.43187 15.2475 2.79158 15.2475 3.16665C15.2475 3.54173 15.0985 3.90144 14.8333 4.16665L8.49992 10.5L5.83325 11.1667L6.49992 8.49999L12.8333 2.16665Z"
                    stroke="#1E1E1E" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                </g>
                <defs>
                  <clipPath id="clip0_582_5824">
                    <rect width="16" height="16" fill="white" transform="translate(0.5 0.5)" />
                  </clipPath>
                </defs>
              </svg>
            </button>
            <button class="delete" (click)="deleteEscalationRule(rule)">
              <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                <path d="M9.66675 14.25L9.66675 11.5" stroke="#F52525" stroke-width="2" stroke-linecap="round" />
                <path d="M13.3333 14.25L13.3333 11.5" stroke="#F52525" stroke-width="2" stroke-linecap="round" />
                <path
                  d="M3.25 6.91666H19.75V6.91666C19.0522 6.91666 18.7033 6.91666 18.4194 7.00278C17.7802 7.19668 17.28 7.69688 17.0861 8.33609C17 8.61998 17 8.96888 17 9.66666V14.8333C17 16.7189 17 17.6618 16.4142 18.2475C15.8284 18.8333 14.8856 18.8333 13 18.8333H10C8.11438 18.8333 7.17157 18.8333 6.58579 18.2475C6 17.6618 6 16.7189 6 14.8333V9.66666C6 8.96888 6 8.61998 5.91388 8.33609C5.71998 7.69688 5.21977 7.19668 4.58057 7.00278C4.29667 6.91666 3.94778 6.91666 3.25 6.91666V6.91666Z"
                  stroke="#F52525" stroke-width="1.5" stroke-linecap="round" />
                <path
                  d="M9.72906 3.58971C9.83351 3.49225 10.0637 3.40613 10.3839 3.34471C10.704 3.28329 11.0963 3.25 11.4999 3.25C11.9035 3.25 12.2958 3.28329 12.616 3.34471C12.9362 3.40613 13.1663 3.49225 13.2708 3.58971"
                  stroke="#F52525" stroke-width="2" stroke-linecap="round" />
              </svg>
            </button>

          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="d-flex justify-content-between align-items-center mt-3 flex-wrap">
    <span style="color: #6D6D6D; font-size: 14px;">
      Showing {{ pagedRules.length }} of {{ filteredRulesList.length }} rules
    </span>

    <div class="d-flex align-items-center gap-2 mt-2 mt-md-0">
      <label class="me-1">Per page:</label>
      <select [(ngModel)]="pageSize" (change)="changePageSize()" class="form-select form-select-sm w-auto">
        <option *ngFor="let size of page_list" [value]="size">{{ size }}</option>
      </select>

      <button class="btn-sm fw-bold px-3 py-1 me-2" (click)="prevPage()" [disabled]="currentPage === 1">&lt;</button>

      <span style="font-weight: 600;">{{ currentPage }} / {{ totalPages }}</span>

      <button class="btn-sm fw-bold px-3 py-1" (click)="nextPage()"
        [disabled]="currentPage === totalPages">&gt;</button>
    </div>
  </div>

</div>
<ng-template #addEscalationModal let-modal>
  <div class="modal-content">

    <div class="modal-header">
      <div>
        <h3 class="modal-title">Add New Escalation Rule</h3>
        <p class="mb-0">Enter escalation rule details to create a new entry.</p>
      </div>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
          <path d="M17.6333 32.3646L32.3666 17.6354M17.6333 17.6354L32.3666 32.3646" stroke="black" stroke-width="1.5"
            stroke-linecap="round" />
        </svg>
      </button>
    </div>

    <div class="modal-body">

      <!-- <div class="modal-row"> -->
        <!-- <div class="form-group">
          <label class="form-label">Complaints Category</label>
          <ng-select [items]="complaintCategories" bindLabel="name" bindValue="name"
            [(ngModel)]="newEscalationRule.category" placeholder="Select Category" [searchable]="true">
          </ng-select>
        </div> -->

        <!-- <div class="form-group">
          <label class="form-label">Level</label>
          <ng-select [items]="escalationLevels" bindLabel="" bindValue="" [(ngModel)]="newEscalationRule.level"
            placeholder="Select Level" [searchable]="false">
          </ng-select>
        </div> -->

      <!-- </div> -->

       <div class="modal-row">
      <div class="form-group">
        <label class="form-label">Escalation Time (hrs)</label>
        <div class="input-with-icon">
          <input type="number" class="form-control" [(ngModel)]="newEscalationRule.time"
            placeholder="Enter Time">
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="14" viewBox="0 0 10 14" fill="none">
            <path
              d="M0.500287 5.46719H9.50029C9.59141 5.46698 9.68073 5.44863 9.75863 5.41411C9.83652 5.37958 9.90006 5.3302 9.94238 5.27128C9.98471 5.21235 10.0042 5.14611 9.99884 5.07968C9.99345 5.01326 9.96335 4.94916 9.91179 4.8943L5.41179 0.147604C5.22529 -0.0492013 4.77629 -0.0492013 4.58929 0.147604L0.0892869 4.8943C0.0371993 4.94905 0.00665394 5.01317 0.000969462 5.07971C-0.00471502 5.14625 0.0146788 5.21265 0.0570438 5.2717C0.0994089 5.33075 0.163125 5.3802 0.241269 5.41466C0.319413 5.44913 0.408997 5.46729 0.500287 5.46719Z"
              fill="#7A7FA1" />
            <path
              d="M9.49971 8.29227L0.499714 8.29227C0.408593 8.29248 0.319276 8.31083 0.241376 8.34535C0.163476 8.37988 0.0999428 8.42926 0.0576159 8.48818C0.015289 8.54711 -0.00422893 8.61335 0.00116218 8.67978C0.0065533 8.7462 0.0366503 8.8103 0.0882136 8.86516L4.58821 13.6119C4.77471 13.8087 5.22371 13.8087 5.41071 13.6119L9.91071 8.86516C9.9628 8.81041 9.99335 8.74629 9.99903 8.67975C10.0047 8.61321 9.98532 8.54681 9.94296 8.48776C9.90059 8.42871 9.83688 8.37926 9.75873 8.3448C9.68059 8.31033 9.591 8.29217 9.49971 8.29227Z"
              fill="#7A7FA1" />
          </svg>
        </div>
      </div>
      <div class="form-group"></div>

</div>
      <!-- <div class="modal-row">
        <div class="form-group">
          <label class="form-label">Notification Modes</label>
          <div class="notification-row ms-3">
            <div *ngFor="let mode of notificationModesList" class="form-check form-check-inline">
              <input type="checkbox" class="form-check-input"
                [checked]="newEscalationRule.notificationModes.includes(mode)"
                (change)="onNotificationModeChange(mode, getCheckedValue($event))">
              <label class="form-check-label">{{ mode }}</label>
            </div>
          </div>
        </div>
      </div> -->

    </div>

    <div class="modal-footer">
      <button type="button" class="btn cancel" (click)="modal.dismiss()">Cancel</button>
      <button type="button" class="btn add" (click)="addEscalationRule()" *ngIf="!newEscalationRule.id">Add Rule</button>
      <button type="button" class="btn add" (click)="updateEscalationRule()" *ngIf="newEscalationRule.id">Update Rule</button>
    </div>

  </div>
</ng-template>